
(function () {
    const COMPANY_ID = "RU2ww8";
    const ADD_RX = /\/cart\/add(?:\.js)?$/i;
    let debounceTimer = null;

    function getRegion() {
        return window.shopType || "NA";
    }


    // Same rule as klaviyo.js and the theme's other Klaviyo client events (hb-datalayer-events.js):
    // only with OneTrust Performance/Analytics (C0002). hasOneTrustCategoryConsent is the inline
    // head helper in layout/theme.liquid; false until a choice is saved, missing counts as no consent.
    function hasKlaviyoConsent () {
        return typeof hasOneTrustCategoryConsent === 'function' && hasOneTrustCategoryConsent('C0002');
    }

    async function sendAddedToCart () {
        await new Promise(r => setTimeout(r, 950));
        if (!hasKlaviyoConsent()) return;

        let cart;
        try {
            cart = await fetch('/cart.js').then(r => r.json());
        } catch (_) { return; }
        if (!cart || !cart.items || !cart.items.length) return;

        const email = window.customerEmail || null;
        if (!email) return;

        const region = getRegion();

        const addedItem = cart.items[0];
        const itemNames = cart.items.map(i => i.product_title);

        const klaviyoItems = cart.items.map(i => {
            const sku = i.sku || "NO-SKU";
            return {
                ProductID:         `${sku}-${region}`,
                ProductName:       i.product_title,
                Quantity:          i.quantity,
                ItemPrice:         i.price / 100,
                RowTotal:          (i.price * i.quantity) / 100,
                ProductURL:        i.url,
                ImageURL:          i.image,
                ProductCategories: i.product_type ? [i.product_type] : []
            };
        });

        const sku = addedItem.sku || "NO-SKU";
        const props = {
            $value:               cart.total_price / 100,
            AddedItemProductName: addedItem.product_title,
            AddedItemProductID:   `${sku}-${region}`,
            AddedItemCategories:  addedItem.product_type ? [addedItem.product_type] : [],
            AddedItemImageURL:    addedItem.image,
            AddedItemURL:         addedItem.url,
            AddedItemPrice:       addedItem.price / 100,
            AddedItemQuantity:    addedItem.quantity,
            ItemNames:            itemNames,
            CheckoutURL:          '/checkout',
            Items:                klaviyoItems
        };

        const eventPayload = {
            data: {
                type: "event",
                attributes: {
                    properties: props,
                    time: new Date().toISOString(),
                    metric: {
                        data: {
                            type: "metric",
                            attributes: { name: "Added to Cart" , service: "shopify"}
                        }
                    },
                    profile: {
                        data: {
                            type: "profile",
                            attributes: { email: email }
                        }
                    }
                }
            }
        };

        // Checked again: the choice can change during the wait and the cart request.
        if (!hasKlaviyoConsent()) return;

        try {
            await fetch("https://a.klaviyo.com/client/events/?company_id=" + encodeURIComponent(COMPANY_ID), {
                method: "POST",
                headers: { "content-type": "application/json", "revision": "2025-04-15" },
                body: JSON.stringify(eventPayload)
            });
        } catch (_) {}
    }

    function scheduleSend () {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(sendAddedToCart, 50);
    }

    const nativeFetch = window.fetch;
    window.fetch = function (resource, config = {}) {
        const url    = typeof resource === 'string' ? resource : resource && resource.url;
        const method = ((config && config.method) || 'GET').toUpperCase();
        if (method === 'POST' && ADD_RX.test(url || '')) scheduleSend();
        return nativeFetch.apply(this, arguments);
    };

    if (window.XMLHttpRequest) {
        const XHR      = window.XMLHttpRequest;
        const origOpen = XHR.prototype.open;
        const origSend = XHR.prototype.send;

        XHR.prototype.open = function (method, url) {
            this.__isATC = (method || 'GET').toUpperCase() === 'POST' && ADD_RX.test(url || '');
            return origOpen.apply(this, arguments);
        };
        XHR.prototype.send = function () {
            if (this.__isATC) scheduleSend();
            return origSend.apply(this, arguments);
        };
    }
})();
